const { cELM, Wrap4Arrow, getWindowWidth, getParameterByName } = require("../../utils");
const Chat = require("../../chat");
const SignaturePad = require("../../../libs/signature_pad.min.js");
let signaturePad = undefined;

SignaturePad.prototype.getSignatureSize = function () {

  let imgWidth = this._ctx.canvas.width;
  let imgHeight = this._ctx.canvas.height;
  let imageData = this._ctx.getImageData(0, 0, imgWidth, imgHeight),
  data = imageData.data,

  getAlpha = function(x, y) {
      return data[(imgWidth*y + x) * 4 + 3]
  },
  scanY = function (fromTop) {
      let offset = fromTop ? 1 : -1;

      // loop through each row
      for(let y = fromTop ? 0 : imgHeight - 1; fromTop ? (y < imgHeight) : (y > -1); y += offset) {

          // loop through each column
          for(let x = 0; x < imgWidth; x++) {
              if (getAlpha(x, y)) {
                  return y;                        
              }      
          }
      }
      return null; // all image is white
  },
  scanX = function (fromLeft) {
      let offset = fromLeft? 1 : -1;

      // loop through each column
      for(let x = fromLeft ? 0 : imgWidth - 1; fromLeft ? (x < imgWidth) : (x > -1); x += offset) {

          // loop through each row
          for(let y = 0; y < imgHeight; y++) {
              if (getAlpha(x, y)) {
                  return x;                        
              }      
          }
      }
      return null; // all image is white
  };

  let cropTop = scanY(true),
    cropBottom = scanY(false),
    cropLeft = scanX(true),
    cropRight = scanX(false);

  return {
    relevantImgWidth: cropRight-cropLeft,
    relevantImgHeight: cropBottom-cropTop,
    originalImgWidth: imgWidth,
    originalImgHeight : imgHeight
  }
};

const validateSignature = () => {

  //Check for signature dots
  let isValidData = (signaturePad._data || []).reduce((isValid, data) => {
    return isValid && (data || []).length > 1;
  }, true);

  //If signature has dots. Is there any relevant data?
  if (!isValidData) {
    isValidData = (signaturePad._data || []).some(x => (x || []).length > 5)
  }
  
  //Check for signature size
  const rate = 0.2; // 20%
  const sizes = signaturePad.getSignatureSize();

  const widthRatio = sizes.relevantImgWidth / sizes.originalImgWidth;
  const heighRatio = sizes.relevantImgHeight / sizes.originalImgHeight;

  const isValidSignature = ((widthRatio > rate) || (heighRatio > rate)) && isValidData;
  return isValidSignature;
}

class SignatureInput {
  constructor(data, placeholder, type) {
    this._data = data;
    this.element = cELM("div", "option-block");
    this.placeholder = placeholder;
    this.__elements = null;
    this.type = type;

    this.createElement();
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  createElement() {
    const inputContainer = cELM("div", "inputs-wrapper");
    const canvas = cELM("canvas", "canvas-signature");
    const _self = this;

    let width = getWindowWidth() - 70;
    if (width > 460) width = 460;

    canvas.width = width;
    canvas.height = 200;
    signaturePad = new SignaturePad(canvas, { width: width, height: 200 });

    const sWrapperEl = cELM("div", "signature-block");
    const btWrapper = cELM("div", "signature-button");
    const dashEl = cELM("div", "dashed-line");
    const descEl = cELM("div", "question-text", getLngTxt("input.signature"));

    var isKiosk = getParameterByName('from')

    if (isKiosk == 'kiosk') {

      window.addEventListener('touchmove', function(e) {
        if (e.target != canvas)
           canvas.classList.add('two-touch'); //not sure why this allows signature to run now with 2 fingers
      })

      window.addEventListener('touchend', function(e) {
        canvas.classList.remove('two-touch'); //not sure why this allows signature to run now with 2 fingers
      })

      canvas.addEventListener('touchmove', function(e) {
        canvas.classList.remove('two-touch'); //not sure why this allows signature to run now with 2 fingers
      })

    }

    const buttonEl = cELM("div", "continue-button", getLngTxt("button.continue"));
    buttonEl.onclick = function(evt) {
      errorEl.style.display = "none";
      setTimeout(() => {
        const isValidSignature = validateSignature();
        if (isValidSignature) {
          errorEl.style.display = "none";
          Chat.default.send({ 
              id: _self._data.id,
              imageURL: signaturePad.toDataURL() 
            }, 
            null, 
            _self.element
          );
        } else {
          errorEl.style.display = "block";
          signaturePad.clear();
        }
      }, 500)
      
    };

    const buttonElClear = cELM("div", "clear-button clear-button-active", getLngTxt("button.clear"));
    buttonElClear.onclick = function(evt) {
      signaturePad.clear();
      errorEl.style.display = "none";
      buttonEl.classList.remove("continue-button-active");
    };

    signaturePad.onEnd = function() {
      if (!signaturePad.isEmpty()) {
        buttonEl.classList.add("continue-button-active");
      }
    };

    sWrapperEl.addELM(Wrap4Arrow(canvas, true));
    sWrapperEl.addELM(dashEl);
    inputContainer.addELM(sWrapperEl);
    inputContainer.addELM(descEl);

    const errorEl = cELM("div", "signature-error", getLngTxt("input.signature.error"));
    errorEl.style.display = "none";
    inputContainer.addELM(errorEl);

    btWrapper.addELM(buttonEl);
    btWrapper.addELM(buttonElClear);

    this.element.addELM(inputContainer);
    this.element.addELM(btWrapper);

    this.__elements = {
      signaturePad,
      canvas,
    };

    window.addEventListener("resize", this.handleResize.bind(this));
    setTimeout(this.handleResize.bind(this), 200);
    return this.element;
  }

  handleResize() {
    let w = getWindowWidth() - 70;
    if (w > 460) w = 460;

    if (this.__elements.canvas.width !== w) {
      this.__elements.canvas.width = w;
      if (signaturePad) signaturePad.clear();
    }
  }

  reset() {
    this.__elements && this.__elements.signaturePad.clear();
  }

  focus() {}
}

module.exports = SignatureInput;
